import type { RequestMeta } from '@teamworksdev/influencer/sdk';

/**
 * Request details for a Response returned by the Influencer SDK's fetch client.
 *
 * `InfluencerApiError` only carries the `Response` (as `cause`), which has no
 * request method and no access to the `RequestMeta` the call was made with.
 * The custom fetch client records them here so error handling can recover them.
 */
export interface InfluencerRequestContext {
	url: string;
	method: string;
	meta: RequestMeta;
}

const requestContexts = new WeakMap<Response, InfluencerRequestContext>();

export function setInfluencerRequestContext(response: Response, context: InfluencerRequestContext): void {
	requestContexts.set(response, context);
}

export function getInfluencerRequestContext(response: unknown): InfluencerRequestContext | undefined {
	if (!(response instanceof Response)) return undefined;
	return requestContexts.get(response);
}
